import  {useState, useEffect} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import DateRangePickers from '../../sharedComponent/DateRangePickers/DateRangePickers'
import {
  GET_CLIENT_ALLOWED_COMPONENTS,
  GET_CUSTOMER_REPORT,
} from '../../../utils/GraphQLAPI'
import {useLazyQuery} from '@apollo/client'
import moment from 'moment'
import { Spinner} from 'react-bootstrap'
import { useLocation, useParams} from 'react-router-dom'
import {checkEmptyData, statusBadgeClassName} from '../../../utils/helper'
import filterIcon from '../../../_metronic/images/filter.svg'
import filterBlueIcon from '../../../_metronic/images/filterBlueIcon.svg'
import filterFillIcon from '../../../_metronic/images/filter-fill.svg'
import {UsersListPagination} from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import {GetReportModaal} from '../SharedPages/TPVRecordingList/GetReport/GetReportModal'
import searchicon from '../../../_metronic/images/hd_search.svg'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'
type LocationState = {
  filterOptions: any
}
const dateFormat = 'YYYY-MM-DD'
const initialFilter = {
  searchText: '',
  page: 1,
  pageSize: 10,
  fromDate: new Date(
    moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
  ).toISOString(),
  toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
  tpvStatus: null,
}
const CustomerReport = ({colors}: any) => {
    const [filterOptions, setFilterOptions] = useState<any>(initialFilter);
    const [localFilterOptions, setLocalFilterOptions] = useState({
      searchText: '',
      page: 1,
      pageSize: 10,
      fromDate: new Date(
        moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
      ).toISOString(),
      toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
      tpvStatus: null,
    });
    
    const [heading, setHeading] = useState('');
    const [showReportModal, setShowReportModal] = useState<boolean>(false);
    const [dateFilterType, setDateFilterType] = useState<any>('Last 30 Days');
    const [page, updatePage] = useState<any>(0);
    const [customerReport, setCustomerReport] = useState<any>([]);
    
    const location = useLocation();
    const getUrlParams = useParams();
    
    const [getCustomerReportByAgent, {loading: customerReportLoading}] = useLazyQuery(
      GET_CUSTOMER_REPORT,
      {
        fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
        variables: {
          input: filterOptions,
        },
        onCompleted: (data) => {
          setCustomerReport(data.getCustomerReportByAgent);
          console.log(
            '======== getSalesChannelListByUser data',
            data.getCustomerReportByAgent.customers
          );
        },
        onError: (err) => console.log('error', err),
      }
    );
    
    const [getSparkComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
      onCompleted: (data) => {
        if (
          data?.getClientAllowedComponents.includes('agentViewCustomerReport') ||
          data?.getClientAllowedComponents.includes('salesAdminViewCustomerReport')
        ) {
          getCustomerReportByAgent();
        }
      },
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    });
    
    // Effect to set filter options from location state
    useEffect(() => {
      if ((location.state as LocationState)?.filterOptions) {
        setLocalFilterOptions((location.state as LocationState)?.filterOptions);
        setFilterOptions((location.state as LocationState)?.filterOptions);
      }
    }, [location.state]);
    
    // Effect to update filter options when the page changes
    useEffect(() => {
      setFilterOptions((prevOptions: any) => {
        return {...prevOptions, page: page + 1};
      });
    }, [page]);
    
    // Effect to set the heading and URL redirect based on URL parameters
    useEffect(() => {
      if (getUrlParams.adminUser === 'agent') {
        setHeading('Customer Reports');
      } else if (getUrlParams.adminUser === 'salesadmin') {
        setHeading('Customer Reports');
      }
    }, [getUrlParams]);
    
    // Effect to fetch the spark components on mount
    useEffect(() => {
      getSparkComponents();
    }, []);
    
    // Effect to fetch the customer report whenever the filter options change
    useEffect(() => {
      getCustomerReportByAgent();
    }, [filterOptions]);
    
    // Function to open the report modal
    const openReportModal = (e: any, editIdValue: any) => {
      setShowReportModal(true);
    };
    
    // Function to close the report modal
    const handleCloseReportModal = () => {
      setShowReportModal(false);
    };
    
    // Function to handle select changes
    const handleSelectChange = (value: any, option: any) => {
      if (option === 'tpvstatus') {
        if (value === 'null') {
          setLocalFilterOptions((prevOptions: any) => {
            return {...prevOptions, tpvStatus: null};
          });
        } else {
          setLocalFilterOptions((prevOptions: any) => {
            return {...prevOptions, tpvStatus: value};
          });
        }
      }
    };
    
    // Function to update filter options based on date range selection
    const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
      updatePage(0);
      setDateFilterType(objDays);
      setFilterOptions((prevOptions: any) => {
        return {
          ...prevOptions,
          fromDate,
          toDate,
          page: page + 1,
        };
      });
    };
    const updateRowsPerPage = (value: any) => {
        setFilterOptions((prevOptions: any) => {
          return {...prevOptions, perPage: value, page: page + 1}
        })
      }
    return (
    <>
      <div
        className='d-flex flex-row justify-content-between'
        style={{height: '48px', marginBottom: '20px'}}
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>{heading}</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - {heading}</span>
        </div>
        <div className='d-flex gap-5'>
          <div className='m-0 '>
            <button
              className='btn text-gray-600 bg-white fw-bold fs-base ms-5'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              //   onClick={() => getProductSetup()}
            >
              {colors === 'white' ? (
                <img
                  src={
                    JSON.stringify({...initialFilter, fromDate: '', toDate: ''}) ===
                    JSON.stringify({
                      ...filterOptions,
                      //   fromDate: '',
                      //   toDate: '',
                      searchText: '',
                      page: 1,
                      pageSize: 10,
                      //   salesChannelIds: null,
                    })
                      ? filterIcon
                      : filterFillIcon
                  }
                  alt=''
                  className='svg-icon svg-icon-1 text-gray-600'
                />
              ) : (
                <img
                  src={
                    JSON.stringify({...initialFilter, fromDate: '', toDate: ''}) ===
                    JSON.stringify({
                      ...filterOptions,
                      fromDate: '',
                      toDate: '',
                      searchText: '',
                      page: 1,
                      pageSize: 10,
                      //   salesChannelIds: null,
                    })
                      ? filterBlueIcon
                      : filterFillIcon
                  }
                  alt=''
                  className='svg-icon svg-icon-1 text-gray-600'
                />
              )}
              Filter
            </button>

            <div
              className='menu menu-sub menu-sub-dropdown w-350px w-md-550px'
              data-kt-menu='true'
              id='kt_menu_63b3cb4f9c10f'
            >
              <div className='px-7 py-5'>
                <div className='fs-4 fw-bold text-gray-900'>Filter Options</div>
              </div>
              <div className='separator border-gray-200'></div>
              <div className='px-7 py-5'>
                <div className='row row-cols-1 row-cols-lg-2'>
                  {/* {getUrlParams.adminUser === 'systemadmin' && (
                    <div className='col mb-3'>
                      <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                        <span>Sales Channel</span>
                      </label>
                      <select
                        className='form-select form-select-solid'
                        value={
                          localFilterOptions.salesChannelIds === null
                            ? '0'
                            : localFilterOptions.salesChannelIds
                        }
                        onChange={(e) => handleSelectChange(e.target.value, 'salesChannelIds')}
                        aria-label='Select example'
                      >
                        <option value='null'>Select an option</option>
                        {salesChannel?.map((options: any) => {
                          return (
                            <option value={options.salesChannelId}>
                              {options.salesChannelName}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  )} */}

                  <div className='col mb-3'>
                    <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                      <span>TPV Status</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={
                        localFilterOptions.tpvStatus === null
                          ? 'null'
                          : localFilterOptions.tpvStatus
                      }
                      onChange={(e) => handleSelectChange(e.target.value, 'tpvstatus')}
                      aria-label='Select example'
                    >
                      <option value='null'>Select an option</option>
                      <option value='FAILED'>Failed</option>
                      <option value='INCOMPLETE'>Incomplete</option>
                      <option value='PASSED'>Passed</option>
                      <option value='PENDING'>Pending</option>
                      <option value='UNVERIFIED'>Unverified</option>
                    </select>
                  </div>
                </div>
                <div className='d-flex flex-row justify-content-end mt-4'>
                  <button
                    type='button'
                    className='btn btn-light me-3 fs-7 fw-semibold text-gray-600'
                    onClick={() => {
                      setLocalFilterOptions({
                        searchText: '',
                        page: 1,
                        pageSize: 10,
                        fromDate: new Date(
                          moment(moment().subtract(29, 'days').toDate()).format(dateFormat) +
                            'T00:00:00'
                        ).toISOString(),
                        toDate: new Date(
                          moment(moment().toDate()).format(dateFormat) + 'T23:59:00'
                        ).toISOString(),

                        tpvStatus: null,
                      })
                    }}
                  >
                    Reset
                  </button>
                  <button
                    type='button'
                    data-kt-menu-dismiss='true'
                    onClick={() => {
                      setFilterOptions((prev: any) => {
                        return {
                          ...localFilterOptions,
                          searchText: prev.searchText,
                          pageSize: prev.pageSize,
                          fromDate: prev.fromDate,
                          toDate: prev.toDate,
                          page: 1,
                        }
                      })
                    }}
                    className='btn btn-primary fs-7 fw-semibold text-gray-100'
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'} />
        </div>
      </div>
      <KTCard>
        <div className='card card-custom'>
          <div className='card-header card-body pb-0 border-0'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-ecommerce-order-filter='search'
                  className='form-control form-control-solid w-250px pe-14'
                  placeholder='Search'
                  onChange={(e) =>
                    setFilterOptions((prev: any) => {
                      updatePage(0)
                      return {...prev, searchText: e.target.value, page: page + 1}
                    })
                  }
                />
                <span className='svg-icon svg-icon-1 position-absolute me-4' style={{right: 0}}>
                  <img src={searchicon} alt='search' />
                </span>
              </div>
            </div>
            {getUrlParams.adminUser === 'salesadmin' && (
              <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
                <div className={`m-0`}>
                  <button
                    className='btn btn-light-primary btn-active-light-primary fs-6 p-3 w-142px h-43px ms-4'
                    onClick={(e) => openReportModal(e, '')}
                    type='button'
                  >
                    <span className='svg-icon svg-icon-6 svg-icon-muted me-1'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='none'
                        className='bi bi-download'
                        viewBox='0 0 16 16'
                      >
                        <path
                          d='M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z'
                          fill='currentColor'
                        />
                        <path
                          d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                    <span>Get Report</span>
                  </button>
                  {
                    <GetReportModaal
                      show={showReportModal}
                      handleClose={handleCloseReportModal}
                      filterOptions={filterOptions}
                      dateFilterType={dateFilterType}
                    />
                  }
                </div>
              </div>
            )}
          </div>
          <KTCardBody className='pe-0 py-0 min-h-400px' scroll>
            {customerReportLoading ? (
              <div className='text-center'>
                <Spinner animation='border' className='text-gray-600' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
            ) : customerReport.totalCount !== 0 ? (
              <div className='table-responsive-xxl'>
                <table className='table table-row-dashed gy-7 gs-7'>
                  <thead>
                    <tr className='fw-bold fs-6 text-gray-700 border-bottom-2 border-gray-200'>
                      <th className='min-w-200px ps-0 header_title'>Customer First Name</th>
                      <th className='min-w-200px ps-0 header_title'>Customer Last Name</th>
                      {getUrlParams.adminUser === 'salesadmin' && (
                        <th className='min-w-200px ps-0 header_title'>Agent First Name</th>
                      )}
                      {getUrlParams.adminUser === 'salesadmin' && (
                        <th className='min-w-200px ps-0 header_title'>Agent Last Name</th>
                      )}
                      {getUrlParams.adminUser === 'salesadmin' && (
                        <th className='min-w-200px ps-0 header_title'>Agent Email Id</th>
                      )}
                      <th className='min-w-200px ps-0 header_title'>TPV Status</th>
                      <th className='min-w-200px ps-0 header_title'>Confirmation Number</th>
                      <th className='min-w-200px ps-0 header_title'>Unique Id</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerReport?.customers?.map((item: any) => (
                      <tr
                        className='border-bottom-2 '
                        //   onClick={(e) => openQcEdit(item)}
                      >
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                          {checkEmptyData(item?.firstName)}
                        </td>
                        <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                          {checkEmptyData(item?.lastName)}
                        </td>

                        {getUrlParams.adminUser === 'salesadmin' && (
                          <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                            {checkEmptyData(item?.agentFirstName)}
                          </td>
                        )}
                        {getUrlParams.adminUser === 'salesadmin' && (
                          <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                            {checkEmptyData(item?.agentLastName)}
                          </td>
                        )}
                        {getUrlParams.adminUser === 'salesadmin' && (
                          <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                            {checkEmptyData(item?.agentEmailId)}
                          </td>
                        )}
                        <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                          <span className={`${statusBadgeClassName(item?.tpvStatus)}`}>
                            {item?.tpvStatus}
                          </span>
                        </td>
                        <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                          {checkEmptyData(item?.confirmationNumber)}
                        </td>
                        <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                          {checkEmptyData(item?.uniqueId)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
                <div>No Results Found</div>
              </div>
            )}
          </KTCardBody>
          {customerReport.totalCount > 0 ? (
            <div className='card-footer border-0'>
              <UsersListPagination
                page={page}
                total={customerReport.totalCount}
                updatePage={updatePage}
                recordsPerPage={(e: any) => {
                  updateRowsPerPage(parseInt(e))
                }}
                rowsPerPage={filterOptions.pageSize}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </KTCard>
    </>
  )
}

export default CustomerReport
